export default __webpack_public_path__ + "static/media/brush_filter_icon.2faa1018.svg";